<article class="service d-flex flex-column align-items-center gap-4 text-center">
    <div class="service__img-container d-flex justify-content-center">
        <img class="service__img" [src]="service.img" [alt]="service.altImg" width="130" height="130" loading="lazy" decoding="async">
    </div>

    <ng-container *ngIf="isExternal(service.link); else internalLink">
        <a [href]="service.link" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-primary">
            <h3 class="service__title fs-4 fw-normal">{{ service.title }}</h3>
        </a>
    </ng-container>
    <ng-template #internalLink>
        <a [routerLink]="getRouterLink(service.link)" class="text-decoration-none text-primary">
            <h3 class="service__title fs-4 fw-normal">{{ service.title }}</h3>
        </a>
    </ng-template>

    <p class="" [innerHTML]="service.text"></p>
</article>
